'use strict';

// index.js — load is early, init waits for a real document
function boot() {
    /**
     * Entry: defer bootstrap so shared modules (React/react-dom) are available.
     * Avoids "Shared module is not available for eager consumption" with Module Federation.
     */
    import('./initFaro').then(function (_ref) {
        var initFaro = _ref.default;

        window.initGnpdFaro = initFaro;
        if (window.faroData) initFaro(window.faroData);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}